var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-start align-stretch"},[_c('Header',{attrs:{"is-wide":true}}),_c('div',{staticClass:"container grow"},[_c('div',{staticClass:"main-no-side"},[_c('el-result',{attrs:{"icon":_vm.icon,"title":_vm.title,"sub-title":_vm.desc}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }